import { ProductivityActivityType } from './components/Activities/types';
import { ProductivityMindsetType } from './components/Mindset/types';
import { ProductivityObjectiveType } from './components/Objectives/types';
import { ProductivitySkillType } from './components/Skills/types';

export const enum ProductivityDetailsTabsEnum {
  About = 'about',
  Settings = 'settings',
  Mindsets = 'mindsets',
  Goals = 'goals',
  Skills = 'skills',
  Activities = 'activities',
}

export enum AboutFormKeys {
  Name = 'name',
  Description = 'description',
  Goals = 'goals',
}

export enum SettingsFormKeys {
  Roles = 'roles',
}

export type RolesType = {
  orgRoleId: string;
  name: string;
};

export type ProductivityFormValuesType = {
  [ProductivityDetailsTabsEnum.About]: {
    [AboutFormKeys.Name]: {
      id: string;
      label: string;
      trackId?: string;
      trackName?: string;
    };
    [AboutFormKeys.Description]: string;
    [AboutFormKeys.Goals]: string[];
  };
  [ProductivityDetailsTabsEnum.Settings]: {
    [SettingsFormKeys.Roles]: RolesType[];
  };
  [ProductivityDetailsTabsEnum.Mindsets]: ProductivityMindsetType[];
  [ProductivityDetailsTabsEnum.Goals]: ProductivityObjectiveType[];
  [ProductivityDetailsTabsEnum.Skills]: ProductivitySkillType[];
  [ProductivityDetailsTabsEnum.Activities]: ProductivityActivityType[];
};
